import React, { useState } from "react";

const filters = [
  { key: "all", label: "All" },
  { key: "godutch", label: "GoDutch" },
  { key: "yourstory", label: "YourStory" },
  { key: "quizgames", label: "Quiz Games" },
  { key: "bingetales", label: "BingeTales" },
];

const items = [
  // GoDutch
  { cat: "godutch", name: "GoDutch", screen: "Android", img: "portfolio/godutch/gd-1.jpg" },
  { cat: "godutch", name: "GoDutch", screen: "Split Bills", img: "portfolio/godutch/gd-2.jpg" },
  { cat: "godutch", name: "GoDutch", screen: "Dashboard", img: "portfolio/godutch/gd-3.jpg" },
  { cat: "godutch", name: "GoDutch", screen: "Profile", img: "portfolio/godutch/gd-4.jpg" },
  // YourStory
  { cat: "yourstory", name: "YourStory", screen: "Android", img: "portfolio/yourstory/ys-1.jpg", showInAll: true },
  { cat: "yourstory", name: "YourStory", screen: "Flutter", img: "portfolio/yourstory/ys-2.jpg" },
  { cat: "yourstory", name: "YourStory", screen: "Stories", img: "portfolio/yourstory/ys-3.jpg" },
  { cat: "yourstory", name: "YourStory", screen: "Feed", img: "portfolio/yourstory/ys-4.jpg", showInAll: true },
  { cat: "yourstory", name: "YourStory", screen: "Profile", img: "portfolio/yourstory/ys-5.jpg" },
  // Quiz Games (TopQuiz + MobileBaazi merged)
  { cat: "quizgames", name: "TopQuiz", screen: "Quiz Game", img: "portfolio/topquiz/tq-1.jpg" },
  { cat: "quizgames", name: "TopQuiz", screen: "Leaderboard", img: "portfolio/topquiz/tq-2.jpg" },
  { cat: "quizgames", name: "TopQuiz", screen: "Categories", img: "portfolio/topquiz/tq-3.jpg" },
  { cat: "quizgames", name: "TopQuiz", screen: "Results", img: "portfolio/topquiz/tq-4.jpg" },
  { cat: "quizgames", name: "MobileBaazi", screen: "Quiz Game", img: "portfolio/mobilebaazi/mb-1.jpg" },
  { cat: "quizgames", name: "MobileBaazi", screen: "Multiplayer", img: "portfolio/mobilebaazi/mb-2.jpg" },
  { cat: "quizgames", name: "MobileBaazi", screen: "Results", img: "portfolio/mobilebaazi/mb-3.jpg" },
  // BingeTales
  { cat: "bingetales", name: "BingeTales", screen: "Reader", img: "portfolio/bingetales/bt-1.png" },
  { cat: "bingetales", name: "BingeTales", screen: "Home", img: "portfolio/bingetales/bt-2.png" },
  { cat: "bingetales", name: "BingeTales", screen: "Categories", img: "portfolio/bingetales/bt-3.png" },
  { cat: "bingetales", name: "BingeTales", screen: "Featured", img: "portfolio/bingetales/bt-4.png" },
];

// Categories shown in "All" tab (quiz games excluded)
const ALL_CATS = ["godutch", "yourstory", "bingetales"];

const PortfolioAnimation = () => {
  const [active, setActive] = useState("all");

  const visible = active === "all"
    ? items.filter((item, idx, arr) => {
        if (!ALL_CATS.includes(item.cat)) return false;
        if (item.showInAll) return true;
        return arr.findIndex((i) => i.cat === item.cat) === idx;
      })
    : items.filter((i) => i.cat === active);

  return (
    <section className="d2-portfolio" id="portfolio" aria-labelledby="portfolio-title">
      <div className="d2-container">
        <span className="section-label reveal">Work</span>
        <h2 className="section-title reveal reveal-delay-1" id="portfolio-title">Portfolio</h2>
        <p className="section-desc reveal reveal-delay-2">Apps and products I've designed and shipped across Android and Flutter.</p>

        <div className="portfolio-filters reveal reveal-delay-3" role="group" aria-label="Filter projects">
          {filters.map((f) => (
            <button
              key={f.key}
              className={`filter-btn${active === f.key ? " active" : ""}`}
              onClick={() => setActive(f.key)}
            >
              {f.label}
            </button>
          ))}
        </div>

        <div className="d2-portfolio-grid">
          {visible.map((item) => (
            <div
              key={`${item.cat}-${item.name}-${item.screen}`}
              className="portfolio-item"
              tabIndex="0"
              aria-label={`${item.name} — ${item.screen}`}
            >
              <img
                src={`${process.env.PUBLIC_URL}/img/${item.img}`}
                alt={`${item.name} ${item.screen} screenshot`}
                style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top" }}
                loading="lazy"
              />
              <div className="portfolio-label">
                <div className="portfolio-app-name">{item.name}</div>
                <div className="portfolio-app-screen">{item.screen}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioAnimation;
